export default __webpack_public_path__ + "static/3-8520a105c1d73864111a45474df1d1f8.png";